import React, {useState} from "react";
import GenericDataGrid from "Admin/components/AdminComponents/GenericDataGrid";
import { Dialog, DialogContent } from "@mui/material";
import VerCaixa from "./VerCaixa";

function ListCaixas() {
  const [detalhesOpen, setDetalhesOpen] = useState(false)
  const [pointer, setPointer] = useState(null)

  const handleModal = (id) =>{
    setPointer(id)
    setDetalhesOpen(true)
  }

  const fields = [
    { name: 'data_abertura', label: 'Data Abertura' },
    { name: 'data_fechamento', label: 'Data Fechamento' },
    { 
      name: 'valor_abertura', 
      label: 'Valor Abertura',
      render: (item) => `R$ ${item.valor_abertura}`
    },
    { 
      name: 'valor_fechamento', 
      label: 'Valor Fechamento',
      render: (item) => item.valor_fechamento ? `R$ ${item.valor_fechamento}` : 'Aberto'
    }
  ];

  const actions = [
    { label: 'Detalhes', handler: (item) => handleModal(item.id)}
  ];

  return (
  <>
    <GenericDataGrid
      title="Movimentações de Caixa"
      endpoint="/caixas"
      fields={fields}
      actions={actions}
    />
  
    <Dialog 
      open={detalhesOpen && pointer} 
      onClose={() => setDetalhesOpen(false)} 
      PaperProps={{
        style: {
          width: '80vw',
          height: '95vh',
          maxWidth: 'none', 
          maxHeight: 'none',
          }
        }}
        >
          <DialogContent>
            
            <VerCaixa id={pointer} />
          </DialogContent>
      </Dialog>
  </>

  );
}

export default ListCaixas;